import React, { useEffect, useState } from "react";
import "./Alert.css";
import SubTitle from "../../components/common/SubTitle";
import DateRangeSelector from "./DateRangeSelector";
import DeleteConfirmationDialog from "./DeleteConfirmationDialog";
import { formatDate } from "../../utils/formatDate";
import ExpiryIcon from "../../images/alerts/Expiry.svg";
import UsersIcon from "../../images/alerts/Users.svg";
import VehicleIcon from "../../images/alerts/Vehicle.svg";
import {
  Box,
  Typography,
  Card,
  Tabs,
  Tab,
  TextField,
  FormControlLabel,
  Switch,
  Checkbox,
  InputAdornment,
  IconButton,
  Button,
  Container,
  Paper,
  Stack,
  useMediaQuery, useTheme
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  getUserAlerts,
  getVehicleAlerts,
  getExpiryAlerts,
  deleteAlertById,
  updateAlert,
} from "./AlertsApis";
import { useTranslation } from "react-i18next";
const Alert = () => {
  const { t } = useTranslation();
  const [userAlerts, setUserAlerts] = useState([]);
  const [vehicleAlerts, setVehicleAlerts] = useState([]);
  const [expiryAlerts, setExpiryAlerts] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [isUnreadOnly, setIsUnreadOnly] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sortDirection, setSortDirection] = useState("desc");
  const [expandedAlerts, setExpandedAlerts] = useState({});
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));

  // New state for multiple selection
  const [selectedAlerts, setSelectedAlerts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isMultiDeleteModalOpen, setIsMultiDeleteModalOpen] = useState(false);
  useEffect(() => { });
  useEffect(() => {
    const fetchAlerts = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const [user, vehicle, expiry] = await Promise.all([
          getUserAlerts(),
          getVehicleAlerts(),
          getExpiryAlerts(),
        ]);

        // Process user alerts to add isRead property based on statusFlag
        const processedUserAlerts = user.map(alert => ({
          ...alert,
          isRead: alert.statusFlag === "READ"
        }));

        // Process vehicle alerts
        const processedVehicleAlerts = vehicle.map(alert => ({
          ...alert,
          isRead: alert.statusFlag === "READ"
        }));

        // Process expiry alerts
        const processedExpiryAlerts = expiry.map(alert => ({
          ...alert,
          isRead: alert.statusFlag === "READ"
        }));

        setUserAlerts(processedUserAlerts);
        setVehicleAlerts(processedVehicleAlerts);
        setExpiryAlerts(processedExpiryAlerts);
      } catch (err) {
        console.error("Error fetching alerts:", err);
        setError("Failed to load alerts. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchAlerts();
    // Set up polling for new alerts every minute
    const intervalId = setInterval(fetchAlerts, 60000);
    return () => clearInterval(intervalId);
  }, []);
  useEffect(() => {
    // Reset selected alerts when tab changes
    setSelectedAlerts([]);
    setSelectAll(false);
  }, [selectedTab]);
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  console.log(userAlerts, "userAlerts");
  const getAlertsByCategory = () => {
    switch (selectedTab) {
      case 0:
        return [...userAlerts, ...vehicleAlerts, ...expiryAlerts];
      case 1:
        return vehicleAlerts;
      case 2:
        return userAlerts;
      case 3:
        return expiryAlerts;
      default:
        return [];
    }
  };
  const getVisibleAlerts = () => {
    let alerts = getAlertsByCategory();
    // Apply unread filter if enabled
    if (isUnreadOnly) {
      alerts = alerts.filter((alert) => !alert.isRead);
    }
    // Apply search filter
    if (searchTerm) {
      alerts = alerts.filter(
        (alert) =>
          alert.subject &&
          alert.subject.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    // Apply date range filter
    if (startDate && endDate) {
      // Set end date to end of day for inclusive filtering
      const endOfDay = new Date(endDate);
      endOfDay.setHours(23, 59, 59, 999);
      alerts = alerts.filter((alert) => {
        const alertDate = new Date(alert.createdAt);
        return alertDate >= startDate && alertDate <= endOfDay;
      });
    }
    // Sort by date
    alerts.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return sortDirection === "desc" ? dateB - dateA : dateA - dateB;
    });
    return alerts;
  };
  const getAlertIcon = (alert) => {
    // Determine which icon to show based on alert type
    console.log(alert, "naveed laert");
    if (alert.type === "VEHICLE") {
      return <img src={VehicleIcon} />;
    } else if (alert.type === "USER") {
      return <img src={UsersIcon} />;
    } else if (alert.type === "EXPIRY") {
      return <img src={ExpiryIcon} />;
    } else {
      return <NotificationsIcon color="primary" />;
    }
  };
  const getAlertExcerpt = (alert) => {
    // Create a short excerpt from the alert body or a default message
    if (!alert.body) return "No additional details";
    return alert.body.length > 50
      ? `${alert.body.substring(0, 50)}...`
      : alert.body;
  };
  // Get counts for each tab
  const getAllCount = () =>
    userAlerts.length + vehicleAlerts.length + expiryAlerts.length;
  const getVehicleCount = () => vehicleAlerts.length;
  const getUserCount = () => userAlerts.length;
  const getExpiryCount = () => expiryAlerts.length;
  const toggleExpandAlert = (alertId, event) => {
    event.stopPropagation(); // Prevent the row's onClick from firing
    setExpandedAlerts((prev) => ({
      ...prev,
      [alertId]: !prev[alertId],
    }));
  
    // Find the alert to check if it's unread
    const allAlerts = [...userAlerts, ...vehicleAlerts, ...expiryAlerts];
    const alert = allAlerts.find((a) => a.id === alertId);
    if (alert && !alert.isRead) {
      markAlertAsRead(alertId); // Mark as read if unread
    }
  };
  const openAlert = (alert, event) => {
    toggleExpandAlert(alert.id, event); // Pass the event to toggleExpandAlert
  };
  // Handle checkbox selection for a single alert
  const handleSelectAlert = (alertId, event) => {
    event.stopPropagation(); // Prevent row click
    setSelectedAlerts((prev) => {
      if (prev.includes(alertId)) {
        return prev.filter((id) => id !== alertId);
      } else {
        return [...prev, alertId];
      }
    });
  };
  // Handle "select all" checkbox
  const handleSelectAll = (event) => {
    event.stopPropagation();
    const checked = event.target.checked;
    setSelectAll(checked);
    if (checked) {
      // Select all visible alerts
      setSelectedAlerts(getVisibleAlerts().map((alert) => alert.id));
    } else {
      // Deselect all
      setSelectedAlerts([]);
    }
  };
  // Delete a single alert
  const deleteAlert = async (alertId) => {
    try {
      await deleteAlertById(alertId);
      // Update state to remove deleted alert
      setUserAlerts((prev) => prev.filter((a) => a.id !== alertId));
      setVehicleAlerts((prev) => prev.filter((a) => a.id !== alertId));
      setExpiryAlerts((prev) => prev.filter((a) => a.id !== alertId));
      return true;
    } catch (err) {
      console.error("Error deleting alert:", err);
      return false;
    }
  };
  // Delete multiple alerts
  const deleteMultipleAlerts = async () => {
    setIsLoading(true);
    let success = true;
    // Delete alerts one by one
    for (const alertId of selectedAlerts) {
      const result = await deleteAlert(alertId);
      if (!result) {
        success = false;
      }
    }
    setIsLoading(false);
    setIsMultiDeleteModalOpen(false);
    setSelectedAlerts([]);
    setSelectAll(false);
    if (!success) {
      setError("Some alerts could not be deleted. Please try again.");
    }
  };
  // Mark alert as read
  const markAlertAsRead = async (alertId) => {
    try {
      // Find the alert in any of the alert arrays
      const allAlerts = [...userAlerts, ...vehicleAlerts, ...expiryAlerts];
      const alertToUpdate = allAlerts.find(a => a.id === alertId);

      if (alertToUpdate) {
        // Prepare data for API call
        const updatedData = {
          ...alertToUpdate,
          alertStatus: "read",
          statusFlag: "READ"
        };

        // Call the API to update the alert
        await updateAlert(updatedData);

        // Update local state to reflect changes
        setUserAlerts(prev =>
          prev.map(a => (a.id === alertId ? { ...a, isRead: true, alertStatus: "read", statusFlag: "READ" } : a))
        );
        setVehicleAlerts(prev =>
          prev.map(a => (a.id === alertId ? { ...a, isRead: true, alertStatus: "read", statusFlag: "READ" } : a))
        );
        setExpiryAlerts(prev =>
          prev.map(a => (a.id === alertId ? { ...a, isRead: true, alertStatus: "read", statusFlag: "READ" } : a))
        );
      }
    } catch (err) {
      console.error("Error marking alert as read:", err);
      setError("Failed to update alert status. Please try again.");
    }
  };

  // Mark alert as unread
  const markAlertAsUnread = async (alertId) => {
    try {
      // Find the alert in any of the alert arrays
      const allAlerts = [...userAlerts, ...vehicleAlerts, ...expiryAlerts];
      const alertToUpdate = allAlerts.find(a => a.id === alertId);

      if (alertToUpdate) {
        // Prepare data for API call
        const updatedData = {
          ...alertToUpdate,
          alertStatus: "unRead",
          statusFlag: "UNREAD"
        };

        // Call the API to update the alert
        await updateAlert(updatedData);

        // Update local state to reflect changes
        setUserAlerts(prev =>
          prev.map(a => (a.id === alertId ? { ...a, isRead: false, alertStatus: "unRead", statusFlag: "UNREAD" } : a))
        );
        setVehicleAlerts(prev =>
          prev.map(a => (a.id === alertId ? { ...a, isRead: false, alertStatus: "unRead", statusFlag: "UNREAD" } : a))
        );
        setExpiryAlerts(prev =>
          prev.map(a => (a.id === alertId ? { ...a, isRead: false, alertStatus: "unRead", statusFlag: "UNREAD" } : a))
        );
      }
    } catch (err) {
      console.error("Error marking alert as unread:", err);
      setError("Failed to update alert status. Please try again.");
    }
  };
  // Mark multiple alerts as read
  const markMultipleAsRead = async () => {
    try {
      setIsLoading(true);
      const allAlerts = [...userAlerts, ...vehicleAlerts, ...expiryAlerts];

      // Process each selected alert
      for (const alertId of selectedAlerts) {
        const alertToUpdate = allAlerts.find(a => a.id === alertId);

        if (alertToUpdate && !alertToUpdate.isRead) {
          // Prepare data for API call
          const updatedData = {
            ...alertToUpdate,
            alertStatus: "read",
            statusFlag: "READ"
          };

          // Call the API to update the alert
          await updateAlert(updatedData);
        }
      }

      // Update local state for all selected alerts
      setUserAlerts(prev =>
        prev.map(a => (selectedAlerts.includes(a.id) ?
          { ...a, isRead: true, alertStatus: "read", statusFlag: "READ" } : a))
      );
      setVehicleAlerts(prev =>
        prev.map(a => (selectedAlerts.includes(a.id) ?
          { ...a, isRead: true, alertStatus: "read", statusFlag: "READ" } : a))
      );
      setExpiryAlerts(prev =>
        prev.map(a => (selectedAlerts.includes(a.id) ?
          { ...a, isRead: true, alertStatus: "read", statusFlag: "READ" } : a))
      );

      setSelectedAlerts([]);
      setSelectAll(false);
      setIsLoading(false);
    } catch (err) {
      console.error("Error marking multiple alerts as read:", err);
      setError("Failed to update alert statuses. Please try again.");
      setIsLoading(false);
    }
  };

  // Mark multiple alerts as unread
  const markMultipleAsUnread = async () => {
    try {
      setIsLoading(true);
      const allAlerts = [...userAlerts, ...vehicleAlerts, ...expiryAlerts];

      // Process each selected alert
      for (const alertId of selectedAlerts) {
        const alertToUpdate = allAlerts.find(a => a.id === alertId);

        if (alertToUpdate && alertToUpdate.isRead) {
          // Prepare data for API call
          const updatedData = {
            ...alertToUpdate,
            alertStatus: "unRead",
            statusFlag: "UNREAD"
          };

          // Call the API to update the alert
          await updateAlert(updatedData);
        }
      }

      // Update local state for all selected alerts
      setUserAlerts(prev =>
        prev.map(a => (selectedAlerts.includes(a.id) ?
          { ...a, isRead: false, alertStatus: "unRead", statusFlag: "UNREAD" } : a))
      );
      setVehicleAlerts(prev =>
        prev.map(a => (selectedAlerts.includes(a.id) ?
          { ...a, isRead: false, alertStatus: "unRead", statusFlag: "UNREAD" } : a))
      );
      setExpiryAlerts(prev =>
        prev.map(a => (selectedAlerts.includes(a.id) ?
          { ...a, isRead: false, alertStatus: "unRead", statusFlag: "UNREAD" } : a))
      );

      setSelectedAlerts([]);
      setSelectAll(false);
      setIsLoading(false);
    } catch (err) {
      console.error("Error marking multiple alerts as unread:", err);
      setError("Failed to update alert statuses. Please try again.");
      setIsLoading(false);
    }
  };
  // Check if any selected alerts are read/unread
  const hasReadAlerts = selectedAlerts.some((alertId) => {
    const allAlerts = [...userAlerts, ...vehicleAlerts, ...expiryAlerts];
    const alert = allAlerts.find((a) => a.id === alertId);
    return alert && alert.isRead;
  });
  const hasUnreadAlerts = selectedAlerts.some((alertId) => {
    const allAlerts = [...userAlerts, ...vehicleAlerts, ...expiryAlerts];
    const alert = allAlerts.find((a) => a.id === alertId);
    return alert && !alert.isRead;
  });
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f5f7f9",
          minHeight: "100vh",
          minWidth: "90vw",
        }}
      >
        <SubTitle title="Alerts" path="organization > Alerts" />
        <Box sx={{ margin: "0px 40px" }}>
          <Paper
            elevation={4}
            sx={{
              p: 2,
              borderRadius: 2,
              border: "1px solid #A5DCF3",
              position: "relative",
            }}
          >
            <Box sx={{ padding: "20px" }}>
              {error && (
                <Box
                  sx={{
                    backgroundColor: "#f8d7da",
                    color: "#721c24",
                    padding: "10px",
                    marginBottom: "15px",
                    borderRadius: "5px",
                  }}
                >
                  {error}
                </Box>
              )}
              <Card
                variant="none"
                sx={{ borderRadius: "8px", mb: 2, padding: "2px" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: isSmallScreen ? "column" : "row",
                    justifyContent: "space-between",
                    alignItems: isSmallScreen ? "stretch" : "center",
                    borderRadius: "8px",
                  }}
                >
                  <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    variant={isXsScreen ? "scrollable" : "standard"}
                    scrollButtons={isXsScreen ? "auto" : false}
                    allowScrollButtonsMobile={isXsScreen}
                    sx={{
                      background: "#E8EAEE",
                      boxShadow: "rgba(0, 0, 0, 0.24) px 3px 8px",
                      borderRadius: "8px",
                      width: isSmallScreen ? "100%" : "65%",
                      display: "flex",
                      alignItems: "center",
                      padding: "2px",
                      justifyContent: "space-evenly",
                      "& .MuiTab-root": {
                        textTransform: "none",
                        fontWeight: 600,
                        minWidth: isXsScreen ? 80 : 100,
                        flex: isXsScreen ? "none" : 1,
                        padding: isXsScreen ? "6px 8px" : "12px 16px",
                        fontSize: isXsScreen ? "0.75rem" : "inherit",
                      },
                      "& .Mui-selected": {
                        backgroundColor: "white",
                        boxShadow: "rgba(0, 0, 0, 0.24) 4px 3px 8px",
                        zIndex: 2,
                        position: "relative",
                        border: "0.5px solid grey",
                        borderRadius: "8px 8px 0px 0px",
                      },
                      "& .MuiTabs-indicator": {
                        backgroundColor: "#20A8E0",
                        height: "3px",
                        zIndex: "2",
                      },
                    }}
                  >
                    <Tab
                      label={
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexWrap: isXsScreen ? "wrap" : "nowrap",
                          }}
                        >
                          <Typography className="tab-text" sx={{ fontSize: isXsScreen ? "0.75rem" : "inherit" }}>{t("all")}</Typography>
                          <Box
                            sx={{
                              ml: isXsScreen ? 0.5 : 1,
                              backgroundColor: "#B7BFCC",
                              borderRadius: "8px",
                              px: isXsScreen ? 0.8 : 1.5,
                              py: 0.2,
                            }}
                          >
                            <Typography variant="body2" sx={{ fontSize: isXsScreen ? "0.65rem" : "inherit" }}>
                              {getAllCount()}
                            </Typography>
                          </Box>
                        </Box>
                      }
                    />
                    <Tab
                      label={
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexWrap: isXsScreen ? "wrap" : "nowrap",
                          }}
                        >
                          <Typography className="tab-text" sx={{ fontSize: isXsScreen ? "0.75rem" : "inherit" }}>{t("Vehicles")}</Typography>
                          <Box
                            sx={{
                              ml: isXsScreen ? 0.5 : 1,
                              backgroundColor: "#B7BFCC",
                              borderRadius: "8px",
                              px: isXsScreen ? 0.8 : 1.5,
                              py: 0.2,

                            }}
                          >
                            <Typography variant="body2" sx={{ fontSize: isXsScreen ? "0.65rem" : "inherit" }}>
                              {getVehicleCount()}
                            </Typography>
                          </Box>
                        </Box>
                      }
                    />
                    <Tab
                      label={
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexWrap: isXsScreen ? "wrap" : "nowrap",
                          }}
                        >
                          <Typography className="tab-text" sx={{ fontSize: isXsScreen ? "0.75rem" : "inherit" }}>{t("users")}</Typography>
                          <Box
                            sx={{
                              ml: isXsScreen ? 0.5 : 1,
                              backgroundColor: "#B7BFCC",
                              borderRadius: "8px",
                              px: isXsScreen ? 0.8 : 1.5,
                              py: 0.2,
                            }}
                          >
                            <Typography variant="body2" sx={{ fontSize: isXsScreen ? "0.65rem" : "inherit" }}>
                              {getUserCount()}
                            </Typography>
                          </Box>
                        </Box>
                      }
                    />
                    <Tab
                      label={
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexWrap: isXsScreen ? "wrap" : "nowrap",
                          }}
                        >
                          <Typography className="tab-text" sx={{ fontSize: isXsScreen ? "0.75rem" : "inherit" }}>{t("expiry")}</Typography>
                          <Box
                            sx={{
                              ml: isXsScreen ? 0.5 : 1,
                              backgroundColor: "#B7BFCC",
                              borderRadius: "8px",
                              px: isXsScreen ? 0.8 : 1.5,
                              py: 0.2,
                            }}
                          >
                            <Typography variant="body2" sx={{ fontSize: isXsScreen ? "0.65rem" : "inherit" }}>
                              {getExpiryCount()}
                            </Typography>
                          </Box>
                        </Box>
                      }
                    />
                  </Tabs>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      width: isSmallScreen ? "100%" : "auto",
                      justifyContent: isSmallScreen ? "space-between" : "flex-end",
                      mt: isSmallScreen ? 1 : 0
                    }}
                  >                    <TextField
                      placeholder={t("search")}
                      variant="outlined"
                      size="small"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        width: isXsScreen ? "60%" : 200,
                      }}
                    />
                    <FormControlLabel
                      label={t("unread")}
                      sx={{
                        mr: isSmallScreen ? 0 : 1,
                        color: "#183059",
                        fontSize: "10px",
                        // '& .MuiFormControlLabel-label': {
                        //   fontSize: isXsScreen ? '0.75rem' : 'inherit'
                        // }
                      }}
                      control={
                        <Switch
                          checked={isUnreadOnly}
                          onChange={(e) => setIsUnreadOnly(e.target.checked)}
                          size={isXsScreen ? "small" : "medium"}
                          sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: "#20A8E0",
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: "#20A8E0",
                            },
                          }}
                        />
                      }
                    />
                  </Box>
                </Box>
              </Card>
              <Box
                sx={{
                  mb: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <DateRangeSelector
                  startDate={startDate}
                  endDate={endDate}
                  onStartDateChange={setStartDate}
                  onEndDateChange={setEndDate}
                />
                {/* Action buttons for multiple selection */}
                {selectedAlerts.length > 0 && (
                  <Box sx={{ display: "flex", gap: 1 }}>
                    {hasUnreadAlerts && (
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<VisibilityIcon />}
                        onClick={markMultipleAsRead}
                        sx={{ borderRadius: "4px" }}
                      >
                        {t("mark as Read")}
                      </Button>
                    )}
                    {hasReadAlerts && (
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<VisibilityOffIcon />}
                        onClick={markMultipleAsUnread}
                        sx={{ borderRadius: "4px" }}
                      >
                        {t(" mark as Unread")}
                      </Button>
                    )}
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      startIcon={<DeleteIcon />}
                      onClick={() => setIsMultiDeleteModalOpen(true)}
                      sx={{ borderRadius: "4px" }}
                    >
                      {("delete Selected")}({selectedAlerts.length})
                    </Button>
                  </Box>
                )}
              </Box>
              <Card variant="outlined" sx={{ borderRadius: "8px" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 16px",
                    borderBottom: "1px solid #B7BFCC",
                    backgroundColor: "#647490",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                      size="small"
                      checked={selectAll}
                      onChange={handleSelectAll}
                      sx={{
                        pl: 0,
                        color: "white",
                        "&.Mui-checked": {
                          color: "white",
                        },
                      }}
                    />
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, color: "#FFFFFF" }}
                    >
                      {t("Alerts")}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, color: "#FFFFFF" }}
                    >
                      {t("timestamp")}
                    </Typography>
                    <IconButton
                      sx={{ color: "#20A8E0" }}
                      size="small"
                      onClick={() =>
                        setSortDirection((prev) =>
                          prev === "asc" ? "desc" : "asc"
                        )
                      }
                    >
                      <ArrowDropDownIcon
                        sx={{
                          size: 30,
                          transform:
                            sortDirection === "asc"
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Box>
                {isLoading && getVisibleAlerts().length === 0 ? (
                  <Box sx={{ textAlign: "center", padding: "20px" }}>
                    <Typography>{t("loadingAlerts")}...</Typography>
                  </Box>
                ) : getVisibleAlerts().length === 0 ? (
                  <Box sx={{ textAlign: "center", padding: "20px" }}>
                    <Typography>{t("no Alerts Found")}</Typography>
                  </Box>
                ) : (
                  getVisibleAlerts().map((alert) => (
                    <Box key={alert.id}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "12px 16px",
                          borderBottom: expandedAlerts[alert.id]
                            ? "none"
                            : "1px solid #B7BFCC",
                          backgroundColor: alert.isRead ? "#ffffff" : "#f8fafd",
                          "&:hover": { backgroundColor: "#f5f5f5" },
                          cursor: "pointer",
                        }}
                        onClick={(e) => openAlert(alert, e)}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flex: 1,
                          }}
                        >
                          <Checkbox
                            size="small"
                            sx={{ mr: 1 }}
                            checked={selectedAlerts.includes(alert.id)}
                            onChange={(e) => handleSelectAlert(alert.id, e)}
                            onClick={(e) => e.stopPropagation()}
                          />
                          <Box
                            sx={{
                              mr: 2,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {getAlertIcon(alert)}
                          </Box>
                          <Box>
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: alert.isRead ? 400 : 600,
                                mb: 0.5,
                              }}
                            >
                              {alert.subject}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                              {getAlertExcerpt(alert)}
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography variant="body2" color="textSecondary">
                            {formatDate(alert.createdAt)}
                          </Typography>
                          <IconButton
                            size="small"
                            sx={{ ml: 1 }}
                            onClick={(e) => toggleExpandAlert(alert.id, e)}
                          >
                            <ExpandMoreIcon
                              sx={{
                                transform: expandedAlerts[alert.id]
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                                transition: "transform 0.3s",
                              }}
                            />
                          </IconButton>
                        </Box>
                      </Box>
                      {/* Dropdown content - only shown when expanded */}
                      {expandedAlerts[alert.id] && (
                        <Box
                          sx={{
                            padding: "16px 40px",
                            backgroundColor: "#f8fafd",
                            borderBottom: "1px solid #B7BFCC",
                            position: "relative",
                          }}
                        >
                          <Stack spacing={2}>
                            <Typography variant="body1">
                              {alert.body}
                            </Typography>
                            <Stack direction="row" spacing={2}>
                              <Box flex={1}>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                >
                                  <strong>Date:</strong>{" "}
                                  {new Date(
                                    alert.createdAt
                                  ).toLocaleDateString()}
                                </Typography>
                                {alert.vehicleId && (
                                  <Typography
                                    variant="body2"
                                    color="textSecondary"
                                  >
                                    <strong>Vehicle ID:</strong>{" "}
                                    {alert.vehicleId}
                                  </Typography>
                                )}
                              </Box>
                              <Box flex={1}>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                >
                                  <strong>Time:</strong>{" "}
                                  {new Date(
                                    alert.createdAt
                                  ).toLocaleTimeString()}
                                </Typography>
                                {alert.userName && (
                                  <Typography
                                    variant="body2"
                                    color="textSecondary"
                                  >
                                    <strong>User:</strong> {alert.userName}
                                  </Typography>
                                )}
                                {alert.type && (
                                  <Typography
                                    variant="body2"
                                    color="textSecondary"
                                  >
                                    <strong>Type:</strong> {alert.type}
                                  </Typography>
                                )}
                              </Box>
                            </Stack>
                            {/* <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                mt: 1,
                              }}
                            >
                              <Button
                                variant="contained"
                                sx={{
                                  borderRadius: "4px",
                                  backgroundColor: "#20A8E0",
                                  color: "#FFFFFF",
                                  "&:hover": {
                                    backgroundColor: "#20A8E0",
                                  },
                                }}
                              >
                                View
                              </Button>
                            </Box> */}
                          </Stack>
                        </Box>
                      )}
                    </Box>
                  ))
                )}
              </Card>
            </Box>
          </Paper>
        </Box>
        <DeleteConfirmationDialog
          open={isMultiDeleteModalOpen}
          onClose={() => setIsMultiDeleteModalOpen(false)}
          onConfirm={deleteMultipleAlerts}
          isLoading={isLoading}
          isMulti
          count={selectedAlerts.length}
        />
      </Box>
    </>
  );
};
export default Alert;

